export const initialState = {
  sendVerifyData: {
    error: '',
    data: null,
    loading: false,
    verifyItem: null,
  },
  confirmCodeData: {
    error: '',
    data: null,
    loading: false,
  },
  createAccountData: {
    error: '',
    data: null,
    loading: false,
  },
  createPatientData: {
    error: '',
    data: null,
    loading: false,
  },
  patientKin: {
    error: '',
    data: null,
    loading: false,
  },
};
